module.exports = __webpack_public_path__ + "img/yonghu.891aba66.png";